export default __webpack_public_path__ + "static/media/FMA_Icon.efec392a.svg";